import { ADD_ONESIGNAL_ID} from "./types";

export const saveOneSignalData = (oneSignalData) => (dispatch) => {
    return dispatch({
        type: ADD_ONESIGNAL_ID,
        payload: {
            oneSignalData: oneSignalData
        }
    });
}